
import { Vue, Prop, Watch } from "vue-property-decorator";
// import { Moment, isMoment } from 'moment';
import moment from "moment";
const views = ["minutes", "hours", "days", "months", "years"];

const validatorView = function (value: string): boolean {
  return views.indexOf(value) !== -1;
};

export default class Tirscript3DateTime extends Vue {
  @Prop({ default: () => new Date(), type: Date }) date: Date;
  @Prop({ default: () => new Date(), type: Date }) dateSecond: Date;
  @Prop({ default: null, type: Date }) minimumDate: Date;
  // ограничение даты сверху
  @Prop({ default: null, type: Date }) maximumDate: Date;
  @Prop({ type: String, validator: validatorView }) initialView: String;
  @Prop({ default: "years", type: String, validator: validatorView })
  minimumView: string;
  @Prop({ default: "months", type: String, validator: validatorView })
  maximumView: string;
  @Prop({ default: null, type: String }) linkedDatePickerName: string;
  @Prop({ default: false, type: Boolean }) isDateRange: boolean;
  @Prop({ default: () => [] }) eventDates: Array<any>;
  @Prop({ default: true }) showCurrentDate: boolean;

  innerCurrentView = this.getInitialView();
  innerDay: number;
  innerMonth: number;
  innerYear: number;
  innerHour: number;
  innerMinute: number;
  innerDate: Date = new Date();
  linkedDatePicker: string;
  

  @Watch("maximumView")
  @Watch("minimumView")
  validateViewRanges() {
    var invalid =
      views.indexOf(this.minimumView) > views.indexOf(this.maximumView);
    if (invalid) {
      console.error(
        `Maximumview не может быть меньше minimumView. Maximumview=${this.maximumView}, minimumview=${this.minimumView}`
      );
    }
  }
  @Watch("minDate")
  ChangeMinDate() {
    if (this.linkedDatePicker) {
      return this.linkedDatePicker;
    }
    return this.minimumDate;
  }
 @Watch("innerDate")onChangeDate(){
    console.log(this.innerDate,"this.innerDate");
    
    this.$emit("update:modelValue", this.innerDate);

    
    
 }
  created() {
    this.validateViewRanges();
  }
  mounted() {
    
    this.linkedDatePicker = this.linkedDatePickerName;
    this.innerDay = this.date.getDate();
    this.innerMonth = this.date.getMonth();
    this.innerYear = this.date.getFullYear();
    this.innerHour = this.date.getHours();
    this.innerMinute = this.date.getMinutes();
    this.innerDate = this.date;
    this.linkedDatePicker = this.linkedDatePickerName;
  }
  

  getDate() {
    return new Date(this.innerYear, this.innerMonth, this.innerDay);
  }

  NavigatorDatetime(typeView: any) {
    if (this.allowedToShowView(typeView)) {
      this.innerCurrentView = typeView;
    }
  }

  ChangeDatetime(date: Date, typeView: any, type: string) {
    this.innerDate = date;
 
    
  
    this.$emit("change", date, type);
    if (this.allowedToShowView(typeView)) {
      this.ChangeCurrentView(typeView);
    }
  }
  /**
   * Изменить текущее представление
   */
  ChangeCurrentView(typeView: any) {
    this.innerCurrentView = typeView;
  }

  getInitialView(): String {
    if (!this.initialView) return this.maximumView;
    return this.initialView;
  }
  /**
   * Разрешено ли открытие представления
   */
  allowedToShowView(view: any) {
    // debugger
    let minimumViewIndex = views.indexOf(this.minimumView);
    let maximumViewIndex = views.indexOf(this.maximumView);
    let viewIndex = views.indexOf(view);
    return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
  }
  getRequest() {
    return this.date;
  }
}
